import { createApp } from '@wu/widget-core';
import { meta } from './meta';
import { WebsiteTranslator } from './website-translator';

export default createApp(
  { alias: meta.alias, name: meta.name },
  WebsiteTranslator
);
